import { t } from '../i18n';
import { Checkbox, Field, Input } from './ui';

export type AddressDraft = {
  label: string;
  street: string;
  buildingNumber: string;
  city: string;
  postalCode: string;
  contactName: string;
  phone: string;
  notes: string;
  isPrimary: boolean;
};

export const emptyAddress = (isPrimary = false): AddressDraft => ({
  label: isPrimary ? 'משרד ראשי' : '',
  street: '',
  buildingNumber: '',
  city: '',
  postalCode: '',
  contactName: '',
  phone: '',
  notes: '',
  isPrimary,
});

export const addressToPayload = (a: AddressDraft) => ({
  label: a.label.trim(),
  street: a.street.trim() || null,
  buildingNumber: a.buildingNumber.trim() || null,
  city: a.city.trim() || null,
  postalCode: a.postalCode.trim() || null,
  contactName: a.contactName.trim() || null,
  phone: a.phone.trim() || null,
  notes: a.notes.trim() || null,
  isPrimary: a.isPrimary,
});

export function formatAddress(a: { street: string | null; buildingNumber: string | null; city: string | null; postalCode?: string | null }) {
  const line = [a.street, a.buildingNumber].filter(Boolean).join(' ');
  return [line, a.city].filter(Boolean).join(', ') + (a.postalCode ? ` ${a.postalCode}` : '');
}

export function AddressFields({ value, onChange, showPrimary = true, primaryLocked }: { value: AddressDraft; onChange: (a: AddressDraft) => void; showPrimary?: boolean; primaryLocked?: boolean }) {
  const set = (k: keyof AddressDraft) => (e: { target: { value: string } }) => onChange({ ...value, [k]: e.target.value });
  return (
    <div className="form-grid">
      <Field label={t.address.label} required className="span-2" error={value.label.trim() ? null : undefined}>
        <Input value={value.label} onChange={set('label')} placeholder={t.address.labelPlaceholder} />
      </Field>
      <Field label={t.address.street}>
        <Input value={value.street} onChange={set('street')} />
      </Field>
      <div className="form-grid" style={{ gap: 12 }}>
        <Field label={t.address.number}>
          <Input value={value.buildingNumber} onChange={set('buildingNumber')} />
        </Field>
        <Field label={t.address.postal}>
          <Input value={value.postalCode} onChange={set('postalCode')} ltr inputMode="numeric" />
        </Field>
      </div>
      <Field label={t.address.city}>
        <Input value={value.city} onChange={set('city')} />
      </Field>
      <Field label={t.address.contact}>
        <Input value={value.contactName} onChange={set('contactName')} />
      </Field>
      <Field label={t.address.phone}>
        <Input value={value.phone} onChange={set('phone')} ltr inputMode="tel" />
      </Field>
      <Field label={t.address.notes}>
        <Input value={value.notes} onChange={set('notes')} />
      </Field>
      {showPrimary ? (
        <div className="span-2">
          <Checkbox checked={value.isPrimary} disabled={primaryLocked} onChange={(v) => onChange({ ...value, isPrimary: v })}>
            {t.address.primary}
          </Checkbox>
        </div>
      ) : null}
    </div>
  );
}
